module.exports = __webpack_public_path__ + "static/fonts/iconfont.25b85cd9.woff";